/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EvaluationDimensionMaxWeight } from './evaluationDimensionMaxWeight';

/**
 * Configuration for an evaluation dimension
 */
export interface EvaluationDimension {
  description: string;
  systemManaged?: boolean;
  /** Maximum weight this dimension can have (between 0.0 and 1.0) */
  maxWeight?: EvaluationDimensionMaxWeight;
}
